"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasProp = exports.isNonNullObject = void 0;
function isNonNullObject(val) {
    return typeof val === 'object' && val !== null;
}
exports.isNonNullObject = isNonNullObject;
// Still, as of June 18, 2022, Typescript cannot use the 'in' keyword or 'hasOwnProperty' method as a type guard
// See: https://github.com/microsoft/TypeScript/issues/21732
function hasProp(obj, prop) {
    return prop in obj;
}
exports.hasProp = hasProp;
//# sourceMappingURL=typescriptExtensions.js.map